import 'core-js/features/array/at';
import * as smoothscroll from 'seamless-scroll-polyfill';
import './IntersectionObserver';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}
